import React from "react";
import cx from "classnames";

interface SearchIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const SearchIcon = (props: SearchIconProps) => {
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={cx("wbuc-h-4 wbuc-w-4", props.className)}
      style={props.style}
    >
      <path
        d="M14.5 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7-13a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm7 14a.5.5 0 100 1 .5.5 0 000-1zm-7-13a6.5 6.5 0 100 13 6.5 6.5 0 000-13z"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </svg>
  );
};

export default SearchIcon;
